import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  ViewChild,
} from '@angular/core';
import { VisionStep } from '@wizeoo/akm-message-lib';
import { WIZ_EVENT_TYPE, VALUE_ENTER } from '@wizeoo/akm-core-lib';
import { 
  WizBasePopUp,
  WizFocusManager,
  WizTextInput,
  WizTranslationBasic,
  WizValidationContainerDirective,
  WizValidationErrors,
  WizEventManager, WizEvent
} from '@wizeoo/akm-component-lib';
import { VisionStepVO } from '@wizeoo/akm-common-lib';
import { Model } from 'src/app/model/model';

@Component({
  selector: 'step-edit-pop',
  templateUrl: './step-edit.pop.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
/** édition label & desc sur step */
export class StepEditPop extends WizBasePopUp {
  @ViewChild(WizValidationContainerDirective, { read: WizValidationContainerDirective })
  private validationContainer: WizValidationContainerDirective;

  @ViewChild('tiCode', { read: WizTextInput, static: true }) tiCode: WizTextInput;
  @ViewChild('tiLabel', { read: WizTranslationBasic, static: true }) tiLabel: WizTranslationBasic;
  @ViewChild('tiDescription', { read: WizTranslationBasic, static: true }) tiDescription: WizTranslationBasic;

  constructor(public elementRef: ElementRef, private cdref: ChangeDetectorRef) {
    super();
  }
  public declare datas: VisionStep;

  private _isValidable: boolean = false;
  public get isValidable(): boolean {
    // activation du bouton de sauvegarde
    return this._isValidable;
  }

  // encapsulation en VO pour faciliter les rendus
  private _visionStepVO: VisionStepVO = null;
  public get visionStepVO(): VisionStepVO {
    if(!this._visionStepVO) {
      this._visionStepVO = new VisionStepVO(this.datas);
    } 
    return this._visionStepVO;
  }

  // validation sur enter
  @HostListener('window:keydown', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.key === VALUE_ENTER && this.isValidable) {
      this.validate();
    }
  }

  show() {
    this.tiCode.wizValue = this.visionStepVO.code;

    this.tiLabel.translationData = Model.getInstance().localeEngine.buildTranslationData(this.visionStepVO.labelVO);
    this.tiDescription.translationData = Model.getInstance().localeEngine.buildTranslationData(this.visionStepVO.descriptionVO);

    // focus du premier champ
    WizFocusManager.getInstance().wizSetFocus(this.tiLabel);

    WizEventManager.addListener(this, this, WIZ_EVENT_TYPE.MODEL_UPDATE, this.onModelUpdate);
  }

  onModelUpdate(e: WizEvent): void {
    const errors: WizValidationErrors = this.validationContainer.check(true);
    this._isValidable = !!errors || errors.length === 0;
    this.cdref.markForCheck();
  }

  validate(): void {
    console.log(this.datas);
    this.tiLabel.entryDS.getSource().forEach((entry) => this.visionStepVO.labelVO.updateTranslationEntry(entry));
    this.tiDescription.entryDS.getSource().forEach((entry) => this.visionStepVO.descriptionVO.updateTranslationEntry(entry));

    if (!!this.callback) {
      this.callback(this.datas);
    }
    this.hide();
  }

  hide() {
    WizEventManager.removeListener(this, this, WIZ_EVENT_TYPE.MODEL_UPDATE);
    super.hide();
  }
}
